import { useTranslation } from "react-i18next";
import styled from "styled-components";
import media from "../../styles/media";
import Container from "../ui/Container";
import { ButtonLink } from "../ui/Button";
import { Eyebrow } from "../ui/Typography";
import { ROUTES } from "../../config/routes";
import crisisImage from "../../assets/img/aral-crisis.png";

const Wrapper = styled.section`
  padding: 72px 0;

  ${media.md} {
    padding: 40px 0;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 64px;
  align-items: center;

  ${media.lg} {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;

const Illustration = styled.img`
  width: 100%;
  height: auto;
  border-radius: ${({ theme }) => theme.radii.md};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`;

const Title = styled.h2`
  font-size: ${({ theme }) => theme.fontSizes.h3};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
`;

const Text = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.md};
`;

export function CrisisSection() {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Container>
        <Grid>
          <Illustration src={crisisImage} alt="" loading="lazy" />

          <Content>
            <Eyebrow>{t("ecologicalDisaster")}</Eyebrow>
            <Title>{t("aralSeaCrisisTitle")}</Title>
            <Text>{t("aralSeaCrisisText")}</Text>
            <ButtonLink to={ROUTES.ifas}>{t("readMore3")}</ButtonLink>
          </Content>
        </Grid>
      </Container>
    </Wrapper>
  );
}

export default CrisisSection;
